import * as React from "react";
import { Component } from "react";
// import { loginProps, loginState } from "./interface";
import Button from "../../widgets/button";
import { FieldItem, FIELD_TYPES } from "../../widgets/fields";
import { Link, Redirect } from "react-router-dom";
import { showToaster, toasterTypes } from "../../widgets";
import { authenticationService } from "../../service";
import { loginResponse } from "../../model";
import { UserHelper, Validation } from "../../utils";
import { userRoles } from "../../constants";
class PrivacyPolicy extends Component {
  componentDidMount() {
    // clear localstorage if user not logged
    if (Validation.isUserLogged()) {
      this.setState({ isAuthenticated: true });
    } else {
      localStorage.clear();
    }
  }

  handleOnChange = (event: React.FormEvent<HTMLInputElement>) => {
    const { name, value } = event.currentTarget;
    const state: any = { ...this.state };
    state[name] = value;
    this.setState(state);
  };

  responsiveMenu = () => {
    let navbarToggle = this.select(".mobile-nav-toggle");
    navbarToggle.classList.toggle("bi-list");
    navbarToggle.classList.toggle("bi-x");
    this.select("#navbar").classList.toggle("navbar-mobile");
  };

  closeMobileMenuNav = () => {
    if (this.select("#navbar").classList.contains("navbar-mobile text-black")) {
      let navbarToggle = this.select(".mobile-nav-toggle text-black");
      navbarToggle.classList.toggle("bi-list");
      navbarToggle.classList.toggle("bi-x");
      this.select("#navbar").classList.remove("navbar-mobile");
    }
  };

  select = (el: any, all = false) => {
    el = el.trim();
    return document.querySelector(el);
  };

  //   onSubmit = () => {
  //     // TODO Validation

  //     authenticationService
  //       .loginRequest(this.state.userName, this.state.password)
  //       .subscribe({
  //         next: (data: loginResponse) => {
  //           try {
  //             if (data.status && data.statusCode === 200) {
  //               console.log("User Data", data.userdata);
  //               localStorage.setItem("user", JSON.stringify(data.userdata));
  //               localStorage.setItem(
  //                 "token",
  //                 JSON.stringify(data["x-auth-token"])
  //               );
  //               localStorage.setItem("id", JSON.stringify(data["x-userid"]));
  //               // auth success
  //               this.setState({ isAuthenticated: true });
  //             } else {
  //               showToaster(toasterTypes.ERROR, data.message);
  //             }
  //           } catch (error) {
  //             console.error(error.message);
  //           }
  //         },
  //         error: (error: any) => {
  //           console.log(error);
  //           showToaster(toasterTypes.ERROR, error.message);
  //           window.location.reload();
  //         },
  //         completed: () => {},
  //       });
  //   };

  render() {
    // const {
    //   handleOnChange,
    //   onSubmit,
    //   state: { userName, password, isAuthenticated },
    // } = this;
    // if (isAuthenticated) {
    //   const role: any = UserHelper.getUserDetails()?.user_role_id;
    //   switch (role) {
    //     case userRoles.VOLUNTEER:
    //       return <Redirect to="/volunteerDashboard" />;

    //     case userRoles.STATE_ADMIN:
    //     case userRoles.SUPER_ADMIN:
    //     case userRoles.DISTRICT_ADMIN:
    //       return <Redirect to="/projectListDashboard" />;

    //     default:
    //       return <Redirect to="/" />;
    //   }
    // }

    return (
      <div>
        <main>
          <header id="homeheaderNew" className="d-flex align-items-center">
            <nav id="navbar" className="navbar">
              <div className="homeheader-items">
                <ul>
                  <li className="ml-2 c-hover d-flex align-items-center ">
                    <Link to="/" className="text-white">
                      Home
                    </Link>
                  </li>
                  <li className="ml-2 c-hover d-flex align-items-center">
                    <Link
                      to="/aboutUs"
                      className="text-white"
                      onClick={() => {
                        this.closeMobileMenuNav();
                      }}
                    >
                      About Us
                    </Link>
                  </li>
                  {/* <li className="ml-2 c-hover d-flex align-items-center">
                    <Link
                      to="/testimonials"
                      className="text-white"
                      onClick={() => {
                        this.closeMobileMenuNav();
                      }}
                    >
                      Testimonials
                    </Link>
                  </li> */}

                  <li className="ml-2 c-hover d-flex align-items-center">
                    <Link
                      to="/"
                      className="text-white"
                      onClick={() => {
                        this.closeMobileMenuNav();
                      }}
                    >
                      Projects
                    </Link>
                  </li>
                  <li className="ml-2 c-hover d-flex align-items-center">
                    <Link
                      to="/login"
                      className="text-white"
                      // style={{ color: "white" }}
                      onClick={() => {
                        this.closeMobileMenuNav();
                      }}
                    >
                      Sign In
                    </Link>
                  </li>
                </ul>
                <i
                  className="bi bi-list mobile-nav-toggle"
                  onClick={this.responsiveMenu}
                ></i>
              </div>
            </nav>
          </header>
          <section className=" ">
            {/* <div className="leftsidec mt-7"> */}
            <div className="testhead">Privacy Policy</div>
            <div>
              <h2 className="mt-5 privacyHead">I. INTRODUCTION</h2>

              <p className="privacyText">
                This Privacy Policy is entered into by and between The Art of
                Living, India (the “Organisation”) and you.
              </p>
              <p className="privacyText">
                The organisation understands that your privacy is important to
                you and that you care about how your information is used and
                shared. We respect and value the privacy of everyone who visits
                our website and will only collect and use information in ways
                that are useful to you and in a manner consistent with your
                rights and our obligations under applicable law.
              </p>
              <p className="privacyText">
                This Privacy Policy applies to our use of any and all data
                collected by us in relation to your use of our website. Please
                read this Privacy Policy carefully and ensure that you
                understand it. Your acceptance of our Privacy Policy is deemed
                to occur upon your first visit to our website. If you do not
                accept and agree to this Privacy Policy, you must stop using our
                website immediately.
              </p>
            </div>
            <div>
              <h2 className="privacyHead">II. PURPOSE</h2>

              <p className="privacyText">
                The Organisation is committed to international compliance with
                data protection laws. This Privacy Policy applies worldwide to
                the Organisation and is based on globally accepted, basic
                principles of data protection. The Privacy Policy provides one
                of the necessary framework conditions for cross-border data
                transmission among the Organisation.
              </p>
            </div>
            <div>
               <h2 className="privacyHead">III. APPLICATION OF NATIONAL LAWS</h2>

              <p className="privacyText">
                This Privacy Policy comprises the internationally accepted data
                privacy principles without replacing the existing national laws.
                It supplements the national data privacy laws. The relevant
                national law will take precedence in the event that it conflicts
                with this Privacy Policy, or it has stricter requirements than
                this Privacy Policy. The content of this Privacy Policy will be
                observed in the absence of corresponding national legislation.
                In the event of conflicts between national legislation and the
                Privacy Policy, the Organisation will work to find a practical
                solution that meets the purpose of the Privacy Policy.
              </p>
            </div>
            <div>
               <h2 className="privacyHead">IV. SCOPE</h2>

              <p className="privacyText">
                This Privacy Policy applies only to your use of our website. It
                does not extend to any websites that are linked to from our
                website (whether we provide those links or whether they are
                shared by other users). We have no control over how your data is
                collected, stored or used by other websites and we advise you to
                check the privacy policies of any such websites before providing
                any data to them.
              </p>
              <p className="privacyText">
                Our website is not intended for individuals under 18 years of
                age, without the valid consent of their parent or guardian. If
                we learn that we have collected or received personal information
                from an individual under age 18 without verification of legal
                guardian or parental consent, we will delete that information.
                If you believe that we might have any information from or about
                a child under age 18, please contact us at
                webmaster@artofliving.org.
              </p>
            </div>
            <div>
               <h2 className="privacyHead">V. DATA COLLECTION</h2>

              <p className="privacyText">
                Some data will be collected automatically by our website, other
                data will only be collected if you voluntarily submit it and
                consent to us using it for the purposes set out herein.
                Automatically collected data includes (1) Information about the
                browser type and version used; User information: Frequency,
                recency, # sessions, page visits, usage details, clicks, traffic
                data, website navigation paths (2) your operating system;
                Platform/device (3) your Internet service provider; (4)
                your system, computer details and internet connection, IP
                address; (4) Internal searches: search terms and categories (5)
                Date and time of access E-commerce transaction details if any (6)
                Session: Duration, bounce rates (7) Traffic sources (8) Adwords.
                In the event of abuse, we may block certain IP addresses.
              </p>
            </div>
            <div>
               <h2 className="privacyHead">VI. USE OF DATA</h2>

              <p className="privacyText">
                a) All personal data is stored securely in a manner that
                reasonably protects it from misuse and loss and from
                unauthorized access, modification or disclosure.
              </p>
              <p className="privacyText">
                b) We use your data for: (i) Providing and managing your
                account; (ii) Providing and managing your access to our website;
                (iii) Personalising and tailoring your experience on our
                website; (iv) Supplying our products and services to you; (v)
                Personalising and tailoring our products and services for you;
                (vi) Responding to communications from you; (vii) Supplying you
                with newsletters, alerts etc. via email, that you may have
                subscribed to and that you may unsubscribe or opt-out at any
                time by clicking on the unsubscribe link from such emails or
                from your account profile; (viii) Market research and (ix)
                Analysing your use of our website and gathering feedback to
                enable us to continually improve our website and your user
                experience.
              </p>
              <p className="privacyText">
                c) In some cases, the collection of data may be a statutory or
                contractual requirement, and we will be limited in the products
                and services we can provide you without your consent for us to
                be able to use such data.
              </p>
              <p className="privacyText">
                d) With your permission and/or where permitted by law, we may
                also use your data for marketing purposes which may include
                contacting you by email, telephone, text message, post and/or
                messaging services with information, news and offers on our
                products and/or services. We will not, however, send you any
                unsolicited marketing or spam and will take all reasonable steps
                to ensure that we fully protect your rights and comply with our
                obligations under the applicable relevant laws.
              </p>
              <p className="privacyText">
                e) Advertisers whose content appears on our website may engage
                in what is known as “behavioral advertising” – advertising
                which is tailored to your preferences, based on your activity.
                Your activity is monitored using Cookies, as detailed in our
                Cookie Policy. Please note that we do not control the activities
                of such advertisers, nor the information they collect and use.
              </p>
              <p className="privacyText">
                f) Legal basis: We will ensure that your personal data is
                processed lawfully, fairly, and transparently, without adversely
                affecting your rights. We will only process your personal data
                if at least one of the following basis applies: (i) you have
                given consent to the processing of your personal data for one or
                more specific purposes; (ii) processing is necessary for the
                performance of a contract to which you are a party or in order
                to take steps at the request of you prior to entering into a
                contract; (iii) processing is necessary for compliance with a
                legal obligation to which we are subject; (iv) processing is
                necessary to protect the vital interests of you or of another
                natural person; (v) processing is necessary for the performance
                of a task carried out in the public interest or in the exercise
                of official authority vested in the controller and/or processing
                is necessary for the purposes of the legitimate interests
                pursued by us or by a third party, except where such interests
                are overridden by the fundamental rights and freedoms of the
                data subject which require protection of personal data, in
                particular where the data subject is a child
              </p>
              <p className="privacyText">
                g) Sensitive Information: Sensitive information as defined under
                the relevant national data privacy laws, will be used by us
                only: (i) for the primary purpose for which it was obtained;
                and/or (ii) with your consent; or where required or authorized
                by applicable law.
              </p>
            </div>
            <div>
               <h2 className="privacyHead">VII. STORAGE OF DATA</h2>

              <p className="privacyText">
                a) We only keep your data for as long as we need to in order to
                use it as described t.in the above section (Use of Data), and/or
                for as long as we have your permission to keep it. In any event,
                we will conduct an annual review to ascertain whether we need to
                keep your data. Your data will be deleted if we no longer need
                it for the purpose for which it was obtained, we will take
                reasonable steps to destroy or permanently de-identify your
                data.
              </p>
              <p className="privacyText">
                b) Some or all of your data may be stored outside of your
                country of domicile You accept and agree to this by using our
                website and submitting information to us. If we do store outside
                of your country of domicile, we will take all reasonable steps
                to ensure that your data is treated as safely and securely as it
                would be within your country of domicile.
              </p>
              <p className="privacyText">
                c) Data security is of great importance to us, and to protect
                your data we have put in place suitable physical, electronic and
                managerial procedures to safeguard and secure data collected
                through our website. Notwithstanding the security measures that
                we take, it is important to remember that the transmission of
                data via the internet may not be completely secure and that you
                are advised to take suitable precautions when transmitting data
                to us via the internet.
              </p>
            </div>
            <div>
               <h2 className="privacyHead">VIII. SHARING OF DATA</h2>

              <p className="privacyText">
                a) We may contract with third parties to supply products and
                services to you on our behalf. These may include payment
                processing, delivery of goods, search engine facilities,
                advertising, and marketing. In some cases, the third parties may
                require access to some or all of your data. Where any of your
                data is required for such a purpose, we will take all reasonable
                steps to ensure that your data will be handled safely, securely,
                and in accordance with your rights, our obligations, and the
                obligations of the third party under applicable relevant law.
              </p>
              <p className="privacyText">
                b) We may compile statistics about the use of our website
                including data on traffic, usage patterns, user numbers, sales
                and other information. All such data will be anonymized and will
                not include any personally identifying information. We may from
                time to time share such data with third parties. Data will only
                be shared and used within the bounds of the law.
              </p>
              <p className="privacyText">
                In certain circumstances, we may be legally required to share
                certain data held by us, which may include your personal
                information, for example, where we are involved in legal
                proceedings, where we are complying with the requirements of
                legislation, a court order, or a governmental authority. we do
                not require any further consent from you in order to share your
                data in such circumstances and will comply as required by any
                legally binding request that is made of us.
              </p>
            </div>
            <div>
               <h2 className="privacyHead">IX. USER OPTIONS</h2>

              <p className="privacyText">
                a) When you submit information via our website, you may be given
                options to restrict our use of your data. We aim to give you
                strong controls on our use of your data (including the ability
                to opt-out of receiving emails from us which you may do by
                unsubscribing using the links provided in our emails and by
                managing your account preferences).
              </p>
              <p className="privacyText">
                b) you may also wish to sign up to one or more of the preference
                services operating in your country. These may help to prevent
                you receiving unsolicited marketing. Please note, however, that
                these services will not prevent you from receiving marketing
                communications that you have consented to receive.
              </p>
              <p className="privacyText">
                c) It is important to us that your data is up to date. We will
                take reasonable steps to make sure that your data is accurate,
                complete and up to date. If you find that the information we
                have is not up to date or is inaccurate, please advise us as
                soon as practicable so we can update our records and ensure we
                can continue to provide quality services to you.
              </p>
            </div>
            <div>
               <h2 className="privacyHead">X. RIGHT TO WITHDRAW INFORMATION</h2>

              <p className="privacyText">
                a) You may access certain areas of our website without providing
                any data at all. However, to use all features and functions
                available on our website you may be required to submit or allow
                for the collection of certain data.
              </p>
              <p className="privacyText">
                b) You may restrict your internet browser’s use of Cookies. For
                more information, see our{" "}
                <a href="https://www.artofliving.org/cookie-policy">
                  Cookie Policy
                </a>
                .
              </p>
              <p className="privacyText">
                c) You may withdraw your consent for us to use your personal
                data at any time by deleting your account or by contacting us
                using the details set out herein below, and we will delete your
                data from our systems. However, you acknowledge this may limit
                our ability to provide the best possible products and services
                to you.
              </p>
            </div>
            <div>
               <h2 className="privacyHead">XI. ACCESS TO DATA</h2>

              <p className="privacyText">
                You may access your personal data we hold about you and to
                update and/or correct it, subject to certain exceptions. If you
                wish to access your personal data, please access it through your
                account.
              </p>
              <p className="privacyText">
                On request by you, we will not charge any fee for your access
                request but may charge an administrative fee for providing a
                copy of your personal data, unless otherwise requested by you,
                the information shall be provided in a commonly used electronic
                form. In order to protect your personal data, we may require
                identification from you before releasing the requested
                information.
              </p>
            </div>
            <div>
               <h2 className="privacyHead">XII. SUMMARY RIGHTS</h2>

              <p className="privacyText">
                You have the right to: (i) request access to, deletion of or
                correction of, your personal data held by us; (ii) complain to a
                supervisory authority; (iii) be informed of what data processing
                is taking place; (iii) restrict processing; (iv) data
                portability; (v) object the processing of your personal data;
                (vi) automated decision-making and profiling.
              </p>
              <p className="privacyText">
                To enforce any of the foregoing rights or if you have any other
                questions about our website or this Privacy Policy, please
                contact us using the details set out herein below.
              </p>
            </div>
            <div>
               <h2 className="privacyHead">XIII. AUTOMATED DECISION-MAKING AND PROFILING</h2>

              <p className="privacyText">
                a) In the event that we use personal data for the purposes of
                automated decision-making and those decisions have a legal (or
                similarly significant effect) on you, you have the right to
                challenge such decisions, requesting human intervention,
                expressing their own point of view, and obtaining an explanation
                of the decision from us.
              </p>
              <p className="privacyText">
                b) The right described in the section above does not apply in
                the following circumstances: (i) the decision is necessary for
                the entry into, or performance of, a contract between you and
                us; (ii) the decision is authorized by law; or (iii) you have
                given your explicit consent below.
              </p>
              <p className="privacyText">
                c) Where we use your personal data for profiling purposes, the
                following shall apply: (i) clear information explaining the
                profiling will be provided, including its significance and the
                likely consequences; (ii) appropriate mathematical or
                statistical procedures will be used; (iii) technical and
                organisational measures necessary to minimise the risk of errors
                and to enable such errors to be easily corrected shall be
                implemented; and (iv) all personal data processed for profiling
                purposes shall be secured in order to prevent discriminatory
                effects arising out of profiling.
              </p>
            </div>
            <div>
               <h2 className="privacyHead">XIV. CONTACT US</h2>

              <p className="privacyText">
                If you have any questions about our website or this Privacy
                Policy, please contact us by email at webmaster@artofliving.org.
                Please ensure that your query is clear, particularly if it is a
                request for information about the data we hold about you.
              </p>
            </div>
            <div>
               <h2 className="privacyHead">XV. CHANGES TO THE PRIVACY POLICY</h2>

              <p className="privacyText">
                We may change this Privacy Policy as we may deem necessary from
                time to time, or as may be required by law. Any changes will be
                immediately posted on our website and you will be deemed to have
                accepted the terms of the Privacy Policy on your first use of
                our website following the alterations. We recommend that you
                check this page regularly to keep up-to-date.
              </p>
            </div>
            <div>
               <h2 className="privacyHead">XVII. LANGUAGE</h2>

              <p className="privacyText">
                This Privacy Policy was prepared and written in English. Any
                non-English translations of this Privacy Policy which may be
                made available are provided for convenience only and are not
                legally binding.
              </p>
            </div>
            <div>
               <h2 className="privacyHead">
                XVIII. APPLICABLE FOR PERSONS FROM THE EUROPEAN ECONOMIC AREA
              </h2>
              <h4 className="privacysubhead">a) Legal Framework</h4>

              <p className="privacyText">
                It has been concluded by the European Commission that particular
                countries outside of the European Economic Area (the “EEA” which
                consists of all European Union member states, plus Norway,
                Iceland, and Liechtenstein) require to adequately protect
                personal data. This can be reviewed under European Commission
                adequacy decision. Where data is being transferred from the EEA
                to other countries, we shall comply with legal frameworks that
                ascertain an equivalent level of protection with European Union
                law.
              </p>
              <h4 className="privacysubhead">b) EU-US and Swiss-US Privacy Shield frameworks</h4>

              <p className="privacyText">
                We shall comply with the EU-US and Swiss-US Privacy Shield
                Frameworks as set forth by the US Department of Commerce
                regarding the collection, use, and retention of personal
                information from European Union member countries and
                Switzerland, respectively.
              </p>
              <h4 className="privacysubhead">c) Model Contract Clauses</h4>

              <p className="privacyText">
                The Organisation shares personal information within the
                Organisation and to other trusted businesses or persons to
                process it for us, based on our guidelines and in compliance
                with this Privacy Policy and any other appropriate
                confidentiality and security measures. Your information may be
                transferred, or stored and processed in other countries outside
                of where you live for the purposes as described in this Privacy
                Policy. These data transfers are necessary to provide the
                services to you and to globally operate and provide our products
                to you. We utilize{" "}
                <a href="https://eur-lex.europa.eu/legal-content/EN/TXT/PDF/?uri=CELEX:32010D0087">
                  standard contract clauses
                </a>
                , rely on the European Commission's{" "}
                <a href="https://ec.europa.eu/info/law/law-topic/data-protection/international-dimension-data-protection/adequacy-decisions_en">
                  adequacy decisions
                </a>{" "}
                about certain countries, as applicable, and obtain your consent
                for these data transfers to other countries.
              </p>
            </div>
          </section>

          {/* <section className="bgfooter ">
            <div className="container">
              <div className="corow">
                <div className="col-lg-3 col-md-6 col-xs-6 px-3 footer-info"> */}
                  {/* <div className="footerhead ">About Us</div> */}
                  {/* <img
                src={`${process.env.PUBLIC_URL}/assets/img/Vruksha_logo_white.png`}
                alt="logo"
              /> */}
                  {/* <p className="p mt-2 mb-2 text-black">
                    The Art of Living is a multi-faceted, non-profit
                    organization with a global presence. Founded in 1981 by a
                    world renowned humanitarian and spiritual leader, Gurudev
                    Sri Sri Ravi Shankar ji. */}
                    {/* {props.about_art_of_living} */}
                    {/* Operating in 156 countries, The Art of Living is a non-profit, educational and humanitarian organization founded in 1981 by the world-renowned humanitarian and spiritual teacher - Gurudev Sri Sri Ravi Shankar. All our programs are guided by Gurudev’s philosophy: “Unless we have a stress-free mind and a violence-free society, we cannot achieve world peace.” */}
                  {/* </p> */}
                {/* </div>
                <div className="col-lg-3 col-md-6 col-xs-6 px-3 footer-links">
                  <div>
                    <Link to="/privacyPolicy" className="footerhead ">
                      Privacy Policy
                    </Link>
                  </div>
                  <div>
                    <Link to="/termsAndCondition" className="footerhead ">
                      Terms & Conditions
                    </Link>
                  </div> */}
                  {/* <div className="footerhead ">Privacy & Policy</div> */}
                  {/* <img
                src={`${process.env.PUBLIC_URL}/assets/img/Vruksha_logo_white.png`}
                alt="logo"
              /> */}
                {/* </div>

                <div className="col-lg-2 col-md-4 col-xs-5 px-2 footer-links">
                  <div>
                    <Link to="/" className="footerhead ">
                      Home
                    </Link>
                  </div>
                  <div>
                    <Link to="/login" className="footerhead ">
                      Sign In
                    </Link>
                  </div>
                  <div>
                    <Link to="/signup" className="footerhead ">
                      Register
                    </Link>
                  </div>
                </div>
                <div className="col-lg-2 col-md-4 col-xs-5 px-2 footer-links">
                  <div>
                    <Link to="/aboutUs" className="footerhead ">
                      About Us
                    </Link>
                  </div> */}
                  {/* <div>
                    <Link to="/testimonials" className="footerhead ">
                      Testimonials
                    </Link>
                  </div> */}
                  {/* <div>
                    <Link to="/" className="footerhead ">
                      Projects
                    </Link>
                  </div>
                </div> */}

                {/* <div className="col-lg-2 col-md-4 col-xs-5 px-2 footer-links">
                <div className="footerhead"> Social Media</div>
                <div className="d-flex align-items-center ">
                  <div className="social-links d-none d-md-block mt-half px-2">
                    <a
                      target={"_blank"}
                      href="https://twitter.com/ArtofLiving"
                      className="twitter"
                    >
                      <i className="bi bi-twitter"></i>
                    </a>
                    <a
                      target={"_blank"}
                      href="https://facebook.com/ArtofLiving"
                      className="facebook px-1 "
                    >
                      <i className="bi bi-facebook"></i>
                    </a>
                    <a
                      target={"_blank"}
                      href="https://instagram.com/artofliving"
                      className="instagram px-1"
                    >
                      <i className="bi bi-instagram"></i>
                    </a> */}
                    {/* <Link
                      to={siteData.linkedInAccountLink}
                      className="linkedin px-1"
                    >
                      <i className="bi bi-linkedin"></i>
                    </Link> */}
                  {/* </div>
                </div>
              </div>
              </div>
            </div>
          </section> */}
          {/* <div className="footer-content2">
            <footer id="footer-new">
              <div className="container">
                <div className="">
                  <div className="">
                    <div className="">
                      <div className="">
                        &copy; Copyright{" "}
                        <strong>
                          <span>Mission Green Earth</span>
                        </strong>
                        . All Rights Reserved
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </footer>
          </div> */}
          <section className="bgfooter  ">
            <div className="container">
              <div className="corow">
                <div
                  className="col-lg-5 col-md-2 col-xs-6 px-3 footer-links"
                  style={{ whiteSpace: "nowrap" }}
                >
                  <div>
                    <Link to="/privacyPolicy" className="footerhead ">
                      Privacy Policy
                    </Link>
                  </div>
                  <div>
                    <Link to="/termsAndCondition" className="footerhead ">
                      Terms & Conditions
                    </Link>
                  </div>
                </div>
                <div className="col-lg-4 col-md-3 col-xs-5 px-2 footer-links">
                  <div className="row">
                    <div>
                      <Link to="/" className="footerhead ">
                        Home
                      </Link>
                    </div>
                    <div>
                      <Link to="/login" className="footerhead ">
                        Sign In
                      </Link>
                    </div>
                  </div>
                </div>
                <div
                  className="col-lg-3 col-md-3 col-xs-5 px-2 footer-links"
                  style={{ whiteSpace: "nowrap" }}
                >
                  <div>
                    <Link to="/signup" className="footerhead ">
                      Register
                    </Link>
                  </div>
                  <div>
                    <Link to="/aboutUs" className="footerhead ">
                      About Us
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <div className="footer-content2 ">
            <footer id="footer-new">
              <div className="">
                <div className="">
                  <div className="">
                    <div className="">
                      <div className="footText">
                        &copy; Copyright{" "}
                        <strong>
                          <span>Mission Green Earth</span>
                        </strong>
                        . All Rights Reserved
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </footer>
          </div>
        </main>

        {/* <section id="Login">
          <div className="Container">
            <div className="Login_card">
              <div className="card">
                <div className="text-center Company_Logo mb-3">
                  <Link to="/">
                    <img
                      src={`${process.env.PUBLIC_URL}/assets/img/Vruksha_logo.png`}
                      alt="logo"
                    />
                  </Link>
                </div>

                <div className="email-login">
                  <form>
                    <FieldItem
                      onChange={handleOnChange}
                      value={userName}
                      name="userName"
                      placeholder="Email ID"
                      type={FIELD_TYPES.TEXT}
                      className="form-control"
                    />
                    <FieldItem
                      onChange={handleOnChange}
                      value={password}
                      name="password"
                      placeholder="Password"
                      type={FIELD_TYPES.TEXT_EYE}
                      className="form-control mt-4"
                      iconClassName="loginPasswordEye"
                    />
                  </form>
                </div>

                <span>
                  <Button
                    type="button"
                    onClick={onSubmit}
                    className="btn cta-btn"
                    label="Log In"
                    id="login"
                  />
                </span>
                <ul className="Remmber_Forgot_box">
                  <li>
                    <div className="form-check">
                      <input
                        className="form-check-input "
                        type="checkbox"
                        value=""
                        id="defaultCheck1"
                      />
                      <label className="form-check-label">Remember Me</label>
                    </div>
                  </li>
                  <li className="forget-pass">
                    <Link to="/forgetpassword"> Forgot Password?</Link>
                  </li>
                </ul>

                <div className="Not_registed_box">
                  <p className="subtitle">
                    Not Registered? <Link to="/signup"> Sign-up now</Link>
                  </p>
                </div>

                <div className="social-login">
                  <button className="google-btn">
                    <img
                      alt="Google"
                      src="data:image/svg+xml;base64,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"
                    />
                    <p className="btn-text"> Google</p>
                  </button>
                  <button className="fb-btn">
                    <img
                      alt="FB"
                      src="data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/Pg0KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDE5LjAuMCwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPg0KPHN2ZyB2ZXJzaW9uPSIxLjEiIGlkPSJMYXllcl8xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB4PSIwcHgiIHk9IjBweCINCgkgdmlld0JveD0iMCAwIDI5MS4zMTkgMjkxLjMxOSIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgMjkxLjMxOSAyOTEuMzE5OyIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+DQo8Zz4NCgk8cGF0aCBzdHlsZT0iZmlsbDojM0I1OTk4OyIgZD0iTTE0NS42NTksMGM4MC40NSwwLDE0NS42Niw2NS4yMTksMTQ1LjY2LDE0NS42NmMwLDgwLjQ1LTY1LjIxLDE0NS42NTktMTQ1LjY2LDE0NS42NTkNCgkJUzAsMjI2LjEwOSwwLDE0NS42NkMwLDY1LjIxOSw2NS4yMSwwLDE0NS42NTksMHoiLz4NCgk8cGF0aCBzdHlsZT0iZmlsbDojRkZGRkZGOyIgZD0iTTE2My4zOTQsMTAwLjI3N2gxOC43NzJ2LTI3LjczaC0yMi4wNjd2MC4xYy0yNi43MzgsMC45NDctMzIuMjE4LDE1Ljk3Ny0zMi43MDEsMzEuNzYzaC0wLjA1NQ0KCQl2MTMuODQ3aC0xOC4yMDd2MjcuMTU2aDE4LjIwN3Y3Mi43OTNoMjcuNDM5di03Mi43OTNoMjIuNDc3bDQuMzQyLTI3LjE1NmgtMjYuODF2LTguMzY2DQoJCUMxNTQuNzkxLDEwNC41NTYsMTU4LjM0MSwxMDAuMjc3LDE2My4zOTQsMTAwLjI3N3oiLz4NCjwvZz4NCjxnPg0KPC9nPg0KPGc+DQo8L2c+DQo8Zz4NCjwvZz4NCjxnPg0KPC9nPg0KPGc+DQo8L2c+DQo8Zz4NCjwvZz4NCjxnPg0KPC9nPg0KPGc+DQo8L2c+DQo8Zz4NCjwvZz4NCjxnPg0KPC9nPg0KPGc+DQo8L2c+DQo8Zz4NCjwvZz4NCjxnPg0KPC9nPg0KPGc+DQo8L2c+DQo8Zz4NCjwvZz4NCjwvc3ZnPg0K"
                    />
                    <p className="btn-text"> Facebook</p>
                  </button>
                </div>
              </div>
            </div>

            <div className="Copyright_box">Copyright &copy; 2021, Vruksha</div>
          </div>
        </section> */}
      </div>
    );
  }
}

export default PrivacyPolicy;
